const enUSJson = {
  common: {
    add: "Add",
    edit: "Edit",
    view: "View",
    update: "Update",
    delete: "Delete",
    actions: "Actions",
    apply: "Apply",
    reset: "Reset",
    menu: "Menu",
    search: "Search",
    noDataAvailable: "No Data Available",
    loadingText: "We are loading the data for you. Please wait.",
    cancel: "Cancel",
    select: "Select",
    close: "Close",
    save: "Save",
    saveSuccess: "{{name}} saved successfully.",
    yes: 'Yes',
    no: 'No',
    expand: "Expand",
    collapse: "Collapse",
    downloadPDF: "Download as PDF",
    downloadCSV: "Download as CSV",
    downloadExcel: "Download as Excel",
    tips: {
      downloadFailed: "Download failed."
    },
    tip: {
      addSuccess: "Add successfully.",
      addFailed: "Add failed.",
      updateSuccess: "Update successfully.",
      updateFailed: "Update failed.",
      addSuccessWithName: "{{name}} added successfully.",
      addFailedWithName: "{{name}} added failed.",
      updateSuccessWithName: "{{name}} updated successfully.",
      updateFailedWithName: "{{name}} updated failed.",
      revertSuccess: "Revert successfully.",
      revertFailed: "Revert failed.",
      deleteSuccess: "Delete successfully.",
      deleteFailed: "Delete failed.",
      deletion: "Please enter a reason for deletion.",
      limit_2000: "The input exceeds the maximum limit of 2,000 characters.",
      selectOneItem: "Please select one item.",
      selectTarget: "Please select target first.",
      jsonError: 'Incorrect JSON format. Please enter the correct JSON format.'
    },
    jsonLabel: 'JSON',
    next: "Next",
    disable: "Disable",
    enable: "Enable",
    editable: "Editable",
    readOnly: "Read Only",
    status: "Status",
    type: "Type",
    mandatory: "Mandatory",
    selectAll: "Select All",
    pleaseSelect: "Please select",
    basicInformation: "Basic Information",
    configuration: "Configuration"
  },
  validation: {
    isRequired: "is required",
    regexErrorTip: 'Please enter a valid format',
    numberTooSmallTip: 'The value must be at least {{number}}',
    numberTooBigTip: 'The value must be at most {{number}}',
    numberIntegerOnly: 'Integer only',
    numberMaxDecimalPlaces: "No more than {{number}} decimal places",
    dateTooEarlyTip: 'The selected date must be later than {{date}}',
    dateTooLateTip: 'The selected date must be earlier than {{date}}',
    stringTooShortTip: 'The input characters must be at least {{number}}',
    stringTooLongTip: 'The input exceeds the maximum limit of {{number}}'
  },
  menu: {
    planTrack: "Plan & Track",
    processManager: "Process Manager",
    taskManager: "Task Manager",
    templateManager: "Template Manager",
    templateAutoLauncher: "Template AutoLauncher",
    addDefaultProcess: "Add Default Process",
    viewDefaultProcess: "View Default Process"
  },
  planTrack: {
    processes: "Processes",
    plans: "Plans",
    reports: "Reports",
    tasks: "Tasks",
    report: {
      module: 'Module',
      reportType: 'Report Type',
      reportName: 'Report Name',
    }
  },
  grid: {
    process: "Process",
    processInstanceId: "Process Instance Id",
    parentProcess: "Parent Process",
    taskName: "Task Name",
    objectId: "Object Id",
    parentObjectId: "Parent Object Id",
    object: "Object",
    processTypeName: "Process Type",
    processStatus: "Process Status",
    domain: "Domain",
    module: "Module",
    taskStatus: "Task Status",
    showNotStarted: "Not Started",
    showInProgress: "In Progress",
    showCompleted: "Completed",
    downloadPDF: "Download as PDF",
  },
  process: {
    process: 'Process',
    processName: 'Process Name',
    processOwner: 'Process Owner (s)',
    processInitiator: 'Process Initiator',
    processStartDate: 'Process Start Date',
    task: 'Tasks',
    milestones: 'Milestones',
    // notStarted: 'Not Started',
    // completed: 'Completed',
    // inProgress: 'In Progress',
    plannedStartDate: 'Planned Start Date',
    plannedDuration: 'Planned Duration (Days)',
    plannedEndDate: 'Planned End Date',
    actualStartDate: 'Actual Start Date',
    actualDuration: 'Actual Duration (Days)',
    actualEndDate: 'Actual End Date',
    projectedStartDate: 'Projected Start Date',
    projectedEndDate: 'Projected End Date',
    milestoneName: 'Milestone Name',
    milestoneDate: 'Milestone Date',
    milestone: 'Milestone',
    processID: "Process ID",
    templateVersion: "Template Version",
    associate: {
      associate: "Associate",
      pageHeader: "Associate Process",
      selectProcess: "Select the Process",
      processInitiation: "Process Initiation",
      initiate: "Initiate",
      initiator: "Initiator",
      processInitiators: "Process Initiator(s)",
      emptyProcessTip: "Please select at least one process.",
      associateSuccess: "Process associated successfully.",
      associateFail: "Process associated failed.",
      initiateSuccess: "Process initiated successfully.",
      initiateFail: "Process initiated failed.",
      initiateWarning: "Please fill in the mandatory fields highlighted in red to initiate the process.",
      description: "Description",
      preview: "Preview",
    },
    ownerAndInitiator: "Process Owner and Process Initiator",
    comment: 'Comments',
    attachment: 'Attachment',
    addtask: 'Add Task',
    deletetask: 'Delete Task',
    parallelMultiInstance: "Parallel Multi-Instance Task",
    sequentialMultiInstance: "Sequential Multi-Instance Task",
    deleteMultiTaskComfirm: 'Are you sure you want to delete this task?',
    milestoneExtension: {
      title: "Timeline Adjustment",
      successTip: "Saved successfully.",
      errorTip: "Saved failed.",
    },
    noMilestoneTip: "There are no milestones for this process.",
    autoTemplate: {
      defaultTemplate: "Default Template(s)",
      module: "Module",
      recordType: "Record Type",
      title: "Configure Default Template(s)",
      listTitle: "Template AutoLauncher",
      templateRule: "Template Rules",
      templateRuleTip: "The identifiers defined in different rules for the same record type should be mutually exclusive. If they are not, the system will default to launching the first matching template based on the order of configuration.",
      associateTemplate: "Associate Template",
      templateRequired: "Associate Template is required",
      autoInitiation: "Auto Initiation",
      whenIdentifiers: "When Identifiers",
      selectIdentifiers: "Select Identifiers",
      editIdentifiers: "Edit Identifiers",
      addRule: "Add Rule",
      saveRuleSuccess: "Default Template(s) saved successfully",
      noIdentifiers: "No Identifiers selected",
      addIdentifiersTip: "The rules have been added successfully",
      autoInitiationDisabledTooltip: "Please fill in the selected template's first task's mandatory fields"
    },
    panel: {
      selectElementTip: "Please select an element",
      selectResultTypePH: "Select the Result Type",
      completeSourceNodeTip: "Please complete the source node",
      module: "Module",
      task: "Task",
      section: "Section",
      saveProperties: "Save Properties",
      taskSaveSuccess: "Task saved successfully.",
      conditionSaveSuccess: "Condition saved successfully.",
      resultType: "Result Type",
      outboundCondition: "Outbound Condition",
      atLeastOneTip: "At least one condition is required",
      inboundBasicConditions: "Inbound Basic Conditions",
      basicConditions: "Basic Conditions",
      conditionIsRequired: "Condition is required",
      resultTypeIsRequired: "Result Type is required",
      saveCondition: "Save Condition",
      missingPropertyTip: "The preceding User Task has incomplete required properties. Please complete all properties before configuring the flow.",
    }
  },
  filter: {
    apply: "Apply",
    and: "and",
    clear: "Clear",
    searchIntro: "You can select/unselect to filter content.",
    selected: "Selected",
    more: "More",
    identifiers: "Filters",
    before: "Before",
    after: "After",
    beforeThanPlaceholder: "Select date before than",
    afterThanPlaceholder: "Select date after than",
    fromDatePlaceholder: "Select from date",
    toDatePlaceholder: "Select to date",
    between: "Between",
    total: 'Total',
    reset: 'Reset',
    filterItems: {
      label: "Identifiers",
      totalLabel: "Total identifiers",
      searchPlaceholder: "Search identifiers",
    },
    placeholder: {
      modules: "Modules",
      processes: "Processes",
      processStatuses: "Process Statuses",
      taskStatuses: "Task Statuses",
    },
    selectedCount: "{{count}} selected"
  },
  myTask: {
    task: "Task",
    tasks: "Tasks",
    myTasks: 'My Tasks',
    performTask: 'Perform Task',
    pickTask: 'Pick Task',
    unassignTask: 'Unassign Task',
    showMoreTasks: 'Show more',
    showLessTasks: 'Show less',
    noUnassignedTasks: 'No tasks are currently unassigned.',
    noStartedTasks: 'No tasks are waiting to be started.',
    noInProgressTasks: 'No tasks are currently in progress.',
    noCompletedTasks: 'No tasks have been completed yet.',
    unassigned: 'Unassigned',
    notStarted: 'Not Started',
    inProgress: 'In Progress',
    completed: 'Completed',
    planned: "Planned",
    entityTitle: "Entity Title",
    filter: {
      modules: 'Modules',
      filters: 'Filters',
      apply: 'Apply',
      clear: 'Clear',
      enterSearch: 'Enter keywords to search',
      status: 'Status',
      from: 'From',
      to: 'To',
      all: 'All'
    },
    bulkActions: {
      label: 'Bulk Actions',
      performTasks: 'Perform Tasks',
      performDisabledTip: 'Select at least two tasks of the same type, from the same module, that allow bulk completion.',
      pickTasks: 'Pick Tasks',
      pickDisabledTip: 'Select at least two unassigned tasks to pick.',
      unassignTasks: 'Unassign Tasks',
      unassignDisabledTip: 'Select at least two in progress tasks to unassign.',
      limitsTip: "Due to performance limits, you can only complete up to 100 records in a single batch."
    },
    tips: {
      pickSuccessWithName: "{{name}} picked successfully.",
      pickFailedWithName: "{{name}} picked failed.",
      unassignSuccessWithName: "{{name}} unassigned successfully.",
      unassignFailedWithName: "{{name}} unassigned failed."
    },
    productName: 'Product Name',
    id: 'ID',
    date: 'Date',
    taskOwner: 'Task Owner(s)',
    objectId: 'Object ID'
  },
  processManager: {
    template: "Template",
    templates: "Templates",
    id: "Process Template ID",
    processTemplateName: "Process Template Name",
    processType: "Process Type",
    processTemplateDescription: "Process Template Description",
    processTemplateVersion: "Process BPMN Version",
    taskMandatoryFieldCheck: "Check All Mandatory Fields",
    taskMandatoryFieldCheckTips: "Enable this option to enforce mandatory field validation across all tasks within the process before Initiate. If disabled, mandatory field checks will only apply to the first task",
    editDetails: "Edit Template",
    addDetails: "Add Template",
    cloneTemplate: "Clone Template",
    editBPMN: "Edit BPMN",
    domains: "Process Template Domains",
    addBPMN: "Add BPMN",
    taskManagerTitle: "Task Manager",
    cloneConfirmMessage: "Do you want to clone the selected template?",
    cloneSuccess: "Template has been cloned successfully.",
    cloneError: "Template cloning failed.",
    taskManager: {
      task: "Task",
      taskProperties: 'Task Properties',
      taskId: "Task ID",
      taskName: "Task Name",
      displayName: "Display Name",
      lifecycleIntegration: "Allow Lifecycle Integration",
      lifecycleConcept: "Lifecycle Concept",
      moduleName: "Module Name",
      domainName: "Domain Name",
      configureTask: "Configure Task",
      order: "Order",
      propertyName: "Property Name",
      property: "Property",
      configurability: "Configurability",
      fixed: "Fixed",
      configurable: "Configurable",
      configurabilityInfo: "Fixed means the field value cannot be changed during process execution and Configurable allows the value to be overridden during runtime.",
      detailsPage: {
        sectionTitle: "Process Detail Page Configuration",
        visibility: "Visibility",
        visibilityInfo: "The 'Visibility' field determines whether this field is displayed on the Process Details page."
      },
      section: "Section",
      description: "Description",
      addTask: "Add Task",
      addServiceTask: "Add Service Task",
      addUserTask: "Add User Task",
      editTask: "Edit Task",
      editUserTask: "Edit User Task",
      editServiceTask: "Edit Service Task",
      editProperties: "Edit Properties",
      userTask: "User Task",
      serviceTask: "Service Task",
      lifecycleConceptValue: "Lifecycle Stage",
      triggerTaskStatus: "Trigger Task Status",
      eventIntegration: "Event Integration",
      eventTemplate: "Event Template",
      taskDuration: "Task Duration",
      bulkComplete: "Bulk Complete",
      ruleIntegration: "Rule Integration",
      addRule: "Add Rule",
      rule: "Rule",
      ruleType: "Rule Type"
    },
    templateManager: {
      version: "Version",
      modifiedBy: "Modified By",
      modifiedDate: "Modified Date",
      comment: "Comment",
      viewHistory: "View History",
      addComment: "Add Comment",
      commentPlaceholder: "Please enter your comment",
      emailNotification: "Email Notification",
      enableAllTaskEmailNotification: "Enable email notification for all tasks",
      ccRecipients: "Default CC recipients",
      ccRecipientsTips: "PM Roles that will be CC'd on task emails.",
      addtionalCcRecipients: "Custom CC recipients",
      addtionalCcRecipientsTips: "Users / Groups / Roles that will be CC'd on task emails.",
      emailNotificationConfiguration: "Email Notification Configuration",
      basicInformation: "Basic Information",
    },
  },
};

export default enUSJson;
